module.exports = __webpack_public_path__ + "img/devices.3455745a.svg";